<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M6.38,797.23c0.27-0.79,0.43-1.62,0.47-2.46c1.12-1,1.83-2.45,1.83-4.08c0-3.02-2.43-5.46-5.46-5.46s-5.45,2.43-5.45,5.46
	c0,2.28,1.37,4.22,3.35,5.04c-0.24,0.57-0.62,1.08-1.12,1.47c-2.39-1.19-4.04-3.66-4.04-6.51c0-4.01,3.26-7.28,7.27-7.28
	s7.27,3.27,7.27,7.28C10.5,793.56,8.81,796.05,6.38,797.23L6.38,797.23z M-2.22,801.59c-4.01,0-7.28-3.27-7.28-7.28
	c0-2.87,1.69-5.36,4.12-6.54c-0.26,0.79-0.43,1.61-0.47,2.46c-1.12,1-1.83,2.45-1.83,4.08c0,3.02,2.43,5.46,5.46,5.46
	c3.02,0,5.45-2.43,5.45-5.46c0-2.28-1.37-4.22-3.34-5.04c0.24-0.58,0.62-1.09,1.12-1.47c2.4,1.19,4.05,3.66,4.05,6.51
	C5.05,798.32,1.78,801.59-2.22,801.59L-2.22,801.59z"/>
</svg>

</template>